<template>
  <div>
    <v-dialog v-model="visible" persistent max-width="1100px" >
      <v-card>
        <v-card-title class="green accent-2"> 
          Verifikasi Rekanan: {{ vendorName }}          
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tab" 
            icons-and-text
          >
            <v-tab>
              Perusahaan
              <v-icon v-if="statusPerusahaan === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>              
            </v-tab>
            <v-tab>
              Ijin Usaha
              <v-icon v-if="statusIjin === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Akta
              <v-icon v-if="statusAkta === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Pemilik
              <v-icon v-if="statusPemilik === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Pengurus
              <v-icon v-if="statusPengurus === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Pengalaman
              <v-icon v-if="statusPengalaman === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Pajak
              <v-icon v-if="statusPajak === 'A'">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Sertifikat Vendor
              <v-icon>mdi-help-circle</v-icon>  
            </v-tab>
            <v-tab>
              Blacklist
              <v-icon>mdi-close-circle</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <VerifikasiPerusahaan :Id="vendorId"></VerifikasiPerusahaan>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiIjinUsaha></VerifikasiIjinUsaha>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiAkta></VerifikasiAkta>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiPemilik></VerifikasiPemilik>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiPengurus></VerifikasiPengurus>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiPengalaman></VerifikasiPengalaman>
            </v-tab-item>
            <v-tab-item>
              <VerifikasiPajak></VerifikasiPajak>
            </v-tab-item>
            <v-tab-item>
              <SertifikatVendor :Id="vendorId"></SertifikatVendor>
            </v-tab-item>
            <v-tab-item>
              <BlacklistVendor :Id="vendorId"></BlacklistVendor>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="info" @click="visible=false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { evBus } from '@/main'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API

// import components
import VerifikasiPerusahaan from './VerifikasiPerusahaan'
import VerifikasiIjinUsaha from './VerifikasiIjinUsaha'
import VerifikasiAkta from './VerifikasiAkta'
import VerifikasiPemilik from './VerifikasiPemilik'
import VerifikasiPengurus from './VerifikasiPengurus'
import VerifikasiPengalaman from './VerifikasiPengalaman'
import VerifikasiPajak from './VerifikasiPajak'
import SertifikatVendor from './SertifikatVendor'
import BlacklistVendor from './BlacklistVendor'

export default {
  name: 'Verifikasi',
  components: {
    VerifikasiPerusahaan, VerifikasiIjinUsaha, VerifikasiAkta, VerifikasiPemilik, VerifikasiPengurus, VerifikasiPengalaman, VerifikasiPajak, SertifikatVendor, BlacklistVendor
  },
  computed: {
    statusPerusahaan: function() {
      return this.$store.getters['reg/statusPerusahaan']
    },
    statusIjin: function() {
      return this.$store.getters['reg/statusIjin']
    },
    statusAkta: function() {
      return this.$store.getters['reg/statusAkta']
    },
    statusPemilik: function() {
      return this.$store.getters['reg/statusPemilik']
    },
    statusPengurus: function() {
      return this.$store.getters['reg/statusPengurus']
    },
    statusPengalaman: function() {
      return this.$store.getters['reg/statusPengalaman']
    },
    statusPajak: function() {
      return this.$store.getters['reg/statusPajak']
    },
    vendorId: function() {
      return this.$store.getters['ven/venId']
    },
    vendorName: function() {
      return this.$store.getters['ven/venName']
    },
  },
  data: function() {
    return {
      tab: null,      
      visible: false,      
    }
  },
  methods: {
    updateStoreStatus: function(data) {
      this.$store.dispatch('reg/assignStatusDoc', data)
      // this.$store.commit('reg/setStatusPerusahaan', data.statusPerusahaan) 
      // this.$store.commit('reg/setstatusIjin', data.statusIjin)
      // this.$store.commit('reg/setstatusAkta', data.statusAkta)
      // this.$store.commit('reg/setstatusPemilik', data.statusPemilik)
      // this.$store.commit('reg/setstatusPengurus', data.statusPengurus)
      // this.$store.commit('reg/setstatusPengalaman', data.statusPengalaman)
      // this.$store.commit('reg/setstatusPajak', data.statusPajak)
    }
  },
  mounted: function() {
    evBus.$on('dlgVerifikasi', async (data) => {
      // this.vendorId = data.id
      // this.vendorName = `${data.bentuk} ${data.nama}`
      await axios.get(`${apiUrl}/vendor/${data.id}`)
      .then((response) => {
        this.updateStoreStatus(response.data.data)
      })
      this.visible = true
    })
    evBus.$on('statusPerusahaan', status => {
      this.statusPerusahaan = status
    })
    evBus.$on('statusIjin', status => {
      this.statusIjin = status
    })
    evBus.$on('statusAkta', status => {
      this.statusAkta = status
    })
    evBus.$on('statusPemilik', status => {
      this.statusPemilik = status
    })
    evBus.$on('statusPengurus', status => {
      this.statusPengurus = status
    })
    evBus.$on('statusPengalaman', status => {
      this.statusPengalaman = status
    })
    evBus.$on('statusPajak', status => {
      this.statusPajak = status
    })
  }
}
</script>

<style>

</style>